import PrimaryButton from "../../widgets/Buttons/PrimaryButton";
import Textfield from "../../widgets/Textfield/Textfield";
import PasswordTextfield from "../../widgets/Textfield/PasswordTextfield";
import "./login.scss";

const Login = (props) => {
  const {
    values,
    setFieldValue,
    onSubmit,
    isValid,
    errors,
    dirty,
    touched,
    handleBlur,
    isLoading,
  } = props;


  const getHelperText = (field, requiredMsg) => {
    if (!touched[field]) return "";
    if (!values[field]) return requiredMsg;
    return errors[field] || "";
  };

  const getError = (field) => {
    if (!touched[field]) return false;
    if (!values[field]) return true;
    return Boolean(errors[field]);
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h2>Login</h2>

        <form onSubmit={onSubmit}>
          <Textfield
            id="phone"
            name="phone"
            label="Phone Number"
            type="tel"
            value={values.phone}
            handleOnChange={(e) => {
              const onlyNumbers = e.target.value.replace(/\D/g, "");
              const trimmed = onlyNumbers.slice(0, 10);
              setFieldValue("phone", trimmed);
            }}
            onBlur={handleBlur}
            error={getError("phone")}
            helperText={getHelperText("phone", "Phone number is required")}
            disabled={isLoading}
          />

          <PasswordTextfield
            id="password"
            name="password"
            label="Password"
            value={values.password}
            onChange={(e) => setFieldValue("password", e.target.value)}
            onBlur={handleBlur}
            error={getError("password")}
            helperText={getHelperText("password", "Password is required")}
            disabled={isLoading}
          />

          <PrimaryButton
            type="submit"
            disabled={!isValid || !dirty}
            isLoading={isLoading}
          >
            LOGIN
          </PrimaryButton>
        </form>
      </div>
    </div>
  );
};

export default Login;
